import React from "react";
import Result from "../components/Result";

const PaymentSuccess = () => {
  return <Result type="payment" result="success" />;
};

export default PaymentSuccess;
